import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ILinkClickEvent } from 'common/dynamic-form/dynamic-form.interface';

import { ISPFieldType } from '../../model';
import { ISPFieldTypeBase } from '../field-type-base.class';

/**
 * Link formly field
 */
@Component({
  selector: 'isp-formly-link',
  templateUrl: './link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkFieldComponent extends ISPFieldTypeBase<ISPFieldType.Link> {
  handleLinkClick(event: ILinkClickEvent): void {
    this.dynamicFormService.linkClickEvent.emit(event);
  }
}
